export const D_Menu_items = [
    {
        title:'React JS',
        path:'#reactjs',
        cName:'dropdown-link'
    },
    {
        title:'Featured',
        path:'#projects',
        cName:'dropdown-link'
    },
    {
        title:'Machine Learning',
        path:'#ml_projects',
        cName:'dropdown-link'
    },

]
